import AlertCircleIcon from '@icons/material/AlertCircleIcon';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';

export default function InlineError({ message, title = 'Error' }) {
  return (
    <div css={styles.errorContainer}>
      <AlertCircleIcon
        fill={Colors.rootOrange()}
        height={24}
        width={24}
      />
      <div css={styles.errorContent}>
        <p css={styles.errorTitle}>{title}</p>
        <p css={styles.errorMessage}>{message}</p>
      </div>
    </div>
  );
}

InlineError.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
};

const styles = StyleSheet.create({
  errorContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: Colors.nearWhite(),
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Colors.rootOrange(),
    borderRadius: 6,
    padding: 16,
    marginTop: 24,
    gap: 12,
  },
  errorContent: {
    flex: 1,
  },
  errorTitle: {
    fontWeight: 'bold',
    fontSize: 14,
    color: Colors.nearBlack(),
    margin: 0,
    marginBottom: 4,
  },
  errorMessage: {
    fontSize: 14,
    color: Colors.nearBlack(),
    margin: 0,
  },
});
